export class PersistenceService {
  /**
   * Save data with versioning
   */
  save<T>(key: string, data: T, version: number = 1): void {
    const payload = {
      version,
      timestamp: Date.now(),
      data
    };
    try {
      localStorage.setItem(key, JSON.stringify(payload));
    } catch (e) {
      console.warn('[Persistence] Save failed', e);
    }
  }

  /**
   * Load data and optionally run migrations based on version
   */
  load<T>(key: string, defaultData: T, currentVersion: number = 1, migrator?: (oldData: any, oldVersion: number) => T): T {
    try {
      const stored = localStorage.getItem(key);
      if (!stored) return defaultData;
      
      const parsed = JSON.parse(stored);
      if (!parsed || !parsed.version || !parsed.data) return defaultData;

      if (parsed.version < currentVersion && migrator) {
        return migrator(parsed.data, parsed.version);
      }
      return parsed.data as T;
    } catch (e) {
      console.warn('[Persistence] Load failed', e);
      return defaultData;
    }
  }
}

export const Persistence = new PersistenceService();
